import { useMemo } from 'react';
import { CustomerRoleDto } from '~/lib/data-contract/auto-generated/shop-api-model';
import { useUserProfile } from '~/services/shop/hooks/mit-fog';

export default function useCanUserAccessFunctionality() {
    const { data } = useUserProfile();

    return useMemo(() => {
        if (!data?.user?.currentCustomerRoles) {
            return;
        }
        return {
            isUserAdministrator: isUserAdmin(data?.user?.currentCustomerRoles),
            canExportPrice: canUserExportPriceList(data?.user?.currentCustomerRoles),
            shouldDisplayPrices: shouldDisplayPrices(data?.user?.currentCustomerRoles),
            shouldDisplayPricesExVat: shouldDisplayPricesExVat(data?.user?.currentCustomerRoles),
        };
    }, [data]);
}

// Administrator rolle: Kan oprette andre brugere, der tilknyttes kundenummeret - OG tildele rettigheder
export function isUserAdmin(roles: CustomerRoleDto[]) {
    return (
        roles.includes(CustomerRoleDto.AccountAdministrator) ||
        roles.includes(CustomerRoleDto.Administrator)
    );
}

// Bruger kan bestille prisbog på email via M3
export function canUserExportPriceList(roles: CustomerRoleDto[]) {
    return (
        roles.includes(CustomerRoleDto.AccountAdministrator) ||
        roles.includes(CustomerRoleDto.PriceExportAllowed)
    );
}

// Kan se priser når logget ind
export function shouldDisplayPrices(roles: CustomerRoleDto[]) {
    return (
        roles.includes(CustomerRoleDto.AccountAdministrator) ||
        roles.includes(CustomerRoleDto.SeePricesRole)
    );
}

// Pro kunder skal se priser uden moms
export function shouldDisplayPricesExVat(roles: CustomerRoleDto[]) {
    return roles.includes(CustomerRoleDto.ProCustomer);
}
